import { render, staticRenderFns } from "./BoughtTrainings.vue?vue&type=template&id=6b9d67e6&scoped=true&"
import script from "./BoughtTrainings.vue?vue&type=script&lang=js&"
export * from "./BoughtTrainings.vue?vue&type=script&lang=js&"
import style0 from "./BoughtTrainings.vue?vue&type=style&index=0&id=6b9d67e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d67e6",
  null
  
)

export default component.exports